/**
 * A select (see /styleguide): the platform's own, so iOS's menu in the app,
 * drawn as a control with a chevron. `large` in a form; `block` fills its row.
 */
import * as preact from "preact";

import { cn } from "shared/utils";

export interface SelectOption {
  value: string;
  label: string;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  /** Its options, unless given as children (e.g. in optgroups) */
  options?: SelectOption[];
  size?: "medium" | "large";
  /** An icon font class (e.g. a sort's), before its value */
  icon?: string;
  block?: boolean;
  disabled?: boolean;
  id?: string;
  name?: string;
  class?: string;
  "aria-label"?: string;
  children?: preact.ComponentChildren;
}

export default class Select extends preact.Component<Props> {
  render() {
    const { size, icon, block, options, children } = this.props;
    return (
      <span
        class={cn({
          select: true,
          large: size === "large",
          withIcon: Boolean(icon),
          block,
          [this.props.class ?? ""]: Boolean(this.props.class),
        })}
      >
        {icon ? <i class={icon} aria-hidden="true"></i> : null}
        <select
          id={this.props.id}
          name={this.props.name}
          aria-label={this.props["aria-label"]}
          disabled={this.props.disabled}
          value={this.props.value}
          onChange={(event) => this.props.onChange(event.currentTarget.value)}
        >
          {options
            ? options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))
            : children}
        </select>
      </span>
    );
  }
}
